// extracted by mini-css-extract-plugin
export default {"acceptInvitation":"d0e65bc72555","email":"a9094cde008e"};